import React from 'react';
import styles from './PriceBlock.module.css';
export default function PriceBlock({ dataInfo }) {
  return (
    <section id="5" className={styles.container}>
      <div className={styles.content}>
        <h2 className={styles.title}>💳 Вартість участі</h2>

        <p className={styles.bonus}>
          🎁 <strong>Для нових учасниць — 5 дні безкоштовно! </strong>
          Спробуйте програму без ризику. Тестуйте, відчуйте результат — і тільки потім приймайте
          рішення.
        </p>

        <div className={styles.price_info}>
          <h3>
            Формат 3-тижневої участі в груповому супроводі — <span>600&nbsp;грн</span>
          </h3>

          <ul>
            <li>Щоденна підтримка</li>
            <li>Відповіді на ваші запитання</li>
            <li>Мотивація від мене й інших учасниць</li>
            <li>Середовище, що надихає не зійти з дистанції</li>
          </ul>
        </div>

        <a href={dataInfo.telegtamGropLink} target="_blank" className={styles.btn_join}>
          Приєднатись до групи
        </a>
      </div>
    </section>
  );
}
